export default {
	TitleForm: 'Notification',
	GroupToday: 'Today',
	GroupPrevious: 'Previous',
	FromDate: 'From',
	ToDate: 'To',
	FilterBy: 'Filter by',
	PlaceHoderSearch: 'Enter the transaction code, notification number, notification name',
	Columns: {
		NotificationNo: 'Notices',
		SubmissionCode: 'Symbol',
		TypeService: 'Type of service',
		NotificationName: 'Alert name',
		ReceivedDate: 'Receiving date',
		AgencyNotification: 'Agency notification'
	},
	DoesNotHaveNotification: 'No notifications yet',
	AutoDownloadInv: (numSuccess, numFail) =>
		`Automatically downloaded from tax authorities successfully ${numSuccess} invoice, ${numFail} invoice load failed.`,
	AutoDownloadSuccess: numSuccess =>
		`Automatically downloaded from tax authorities successfully ${numSuccess} invoice.`,
	AutoDownloadFail: numSuccess => `Automatically downloaded from tax authorities failed ${numSuccess} invoice.`,
	Notification: {
		HaveYou: 'You have',
		NoRemind: 'No reminders',
		Understood: 'Got it',
		RemindAndFeature: 'Reminder',
		Views: 'Views',
		ExploreFeatures: 'Explore features',
		PlaceHoderSearch: 'Enter to search',
		Remind: 'Reminder',
		NewFeature: 'New features',
		Extend: 'Extended',
		Colspan: 'Show less',
		InvoiceExpriedDate: 'Invoices are due.',
		Close: 'Close',
		SyncSucess: 'Sync successful',
		InvoiceTax: 'Invoice from Tax Authority',
		Total: 'Total',
		DownloadSuccess: 'Loaded successfully',
		Duplicate: 'Duplicate',
		DownloadFail: 'Failed to load',
		InvoiceProcessing: 'Invoices in processing',
		InvoiceIgnore: 'Invoices ignored',
		InvoiceWaiting: 'Invoices under checking with no results yet',
		ConnectLogin: 'Connect to a sign-in account',
		GovLink: 'hoadondientu.gdt.gov.vn to',
		AutoDownload123:
			'Download all invoice according to Decree No. 70/2025/NĐ-CP automatically from the Tax Authority quickly and completely',
		Skip: 'Skip',
		Detail: 'Details',
		CheckNow: 'Check now',
		ConnectNow: 'Connect now',
		New: 'New',
		FeatureNew: 'New features',
		ViewGuide: 'View help',
		AccountConnectTaxaxion: 'Tax Authority connecting account at branch/department',
		LostConnect: 'disconnected',
		MST: 'Tax Code',
		InvRevEmail: 'Invoice receiving email',
		DateRangeWaiting: dateRange => ` in the last ${dateRange} days`,
		Ignore: 'Ignored',
		InvoiceWaiting1: 'Processing',
		Fail: 'Failed',
		ChangeStatusInvoice: 'Invoices changed status in the last 90 days',
		SupportLicenseHCSN: link =>
			`Due to MISA's policy, please contact administrative business staff for support. <span style='color:#00aab7;cursor: pointer;' onClick=\"window.open('${link}', '_blank')\">See here</span>.`,
		RiskInvoiceBySupplier: (numInvoice, numberDate) =>
			`There are ${numInvoice} invoices not yet reviewed posing a risk within the recent 90 days.`,
		ConnectGovLink: 'Connect with hoadondientu.gdt.gov.vn',
		PleaseReloadPage: 'System data has changed. Please press F5 to get the latest data.',
		Agree: 'Agree',
		ViewList: 'View list',
		SystemBanner: {
			ClickToViewDetail: 'Nhấn để xem chi tiết.',
			Title: 'Thông báo',
			Close: 'Đóng'
		}
	},
	NotHaveNewNotification: 'You do not have any notification!',
	All: 'All',
	Action: 'Action',
	System: 'System',
	Discount: 'Promotion',
	TitleNotification: 'Notification',
	NotificationFeature: 'New features',
	FindMore: 'Find out more',
	SeeTheInstructions: 'See the instructions',
	InstructionsForExtension: 'Instructions for extension',
	InstructionsForAdditionalPurchases: 'Instructions for additional purchases',
	AgoHour: 'hours ago',
	ProcessingSyncDataTax: 'Synchronizing invoice from the Tax Authority',
	ProcessingSyncDataTaxSuccess: (successAmount, totalAmount) =>
		`Successfully synchronized ${successAmount}/${totalAmount} invoices from the Tax Authority`,
	Remind: {
		SuggestOrRecommend: 'Suggestions, recommendations',
		ConnectTaxMissInvoice: 'Why are you missing invoices?',
		InvoiceNotSentToTax:
			'Invoices not sent to the Tax Authority at the time the program automatically downloads invoices',
		NotSetSummaryTable: 'Not set up to get invoices from summary table.',
		HasSetSpecificSupplier: 'Set up not to get invoices from a specific supplier.',
		HasSetMoveAnotherEmail:
			'Invoices automatically forwarded to another email address in the organization due to settings.',
		NotSetAllTypeInvoice: 'Not set up to get all types of invoices.',
		DisconnectTaxAuthority: `Lost connection to the Electronic Invoice Portal (<span style="color: #00aab7">https://hoadondientu.gdt.gov.vn/</span>)`,
		DisconnectTaxaxionTitle: 'Lost connection to the Electronic Invoice Portal',
		DisconnectTaxaxionContent: 'Connection to Tax Authority has been lost. Please check and reconnect.',
		DisconnectTaxaxion: {
			LicenseExpired: 'License has expired. Please renew to continue using the service.',
			ChangeOrLockAccount: 'Connected account has been changed or locked. Please check and update information.',
			NotPermissionLookupInvoice:
				'Account does not have permission to look up invoices. Please check access rights.',
			Default: 'Connection to Tax Authority has been lost. Please check and reconnect.'
		},
		ManageSellerRisk: 'Manage risk and supplier health?',
		CheckSellerRisk: 'Check if the supplier has invoice risk?',
		NotificationMISA: 'Receive notifications from MISA when a seller or supplier stops operating?',
		ViewSupplierActiveStatus: 'Quickly see the operating status of all suppliers and sellers?'
	},
	Assistant: {
		Title: 'Notification & Reminder Assistant',
		TabLatest: 'Latest',
		TabAll: 'All',
		ChatWithAva: 'Chat with AVA assistant',
		NoData: 'No notifications, latest reminders',
		HideNotification: 'Hide notifications',
		AskForAva: 'Ask a question to AVA'
	},
	AvaAssitantAIBot: 'MISA AVA Digital Assistant',
	ChatCommuntityMISA: 'Ask MISA community',
	AmisSupport: 'Chat with counselor',
	InitiAtiveConnect: 'Initiative to connect with the Tax Authority to avoid missing invoices.',
	DayConnect: (dateNow, dateConnect) =>
		`Today is ${dateNow}, you should proactively Synchronize invoices for ${dateConnect} to avoid missing invoices.`,
	InitiAtiveDes:
		'Invoices submitted to the tax authority after the issue date may not be automatically synchronized, including:',
	InitiAtiveDesDetail1:
		'Electricity, water, telecommunications, bank, insurance invoices, etc. (submitted in aggregate form).',
	InitiAtiveDesDetail2: 'Invoices with a digital signature date after the invoice issue date.',
	ConnectGuildHelp: 'View sync guide',
	NotificationTooltip: {
		Title: 'Feature',
		TagNew: 'New'
	},
	NewInvCQTDetail: count => `Download successful ${count} input invoices from Taxixion`,
	NewInvNCCDetail: count => `Download successful ${count} input invoices from suppliers`,
	NewOutCQTDetail: count => `Download successful ${count} output invoices from Taxixion`,
	NewNotiEmail: (count, email) => `Just received  ${count} email that send to ${email}`,
	NewInvoiceChecked: count => `Handled completely ${count} invoices`,
	NewOutInvoice: count => `Handled completely ${count} output invoices`,
	NewDeclaration: count => `Handled completely  ${count} customs declarations`,
	NewSyncInvoiceDetailFromTax: count => `Successfully updated invoice details for ${count} invoices`,
	FinishCheckAgain: number => `There are ${number} inbound invoices that have been rechecked`,
		FinishCheckAgainOut: number => `There are ${number} outbound invoices that have been rechecked`,
	InvoiceSyncAgain: count =>
		`${count} input invoices have changed tax authority status after re-synchronizing from Tax Authority.`,
	OutInvoiceSyncAgain: count =>
		`${count} output invoices have just changed tax authority status after re-synchronizing from Tax Authority.`,
	SubmitMessage: {
		DisconnectTaxaxion: 'How to fix lost connection to Tax Authority'
	}
};
